import { lazy } from 'react';

const SLBuilderForm = lazy(() => import('../pages/SLBuilderForm'));
const SLBuilderPage = lazy(() => import('../pages/SLBuilderPage'));

const slBuilderRoute = {
  public: [],
  auth: [
    {
      name: 'sl_builder_form',
      path: '/finance-and-accounting/sl/builder',
      component: SLBuilderForm,
    },
    // @TODO charles
    {
      name: 'sl_builder_page',
      path: '/finance-and-accounting/sl/:page_id',
      component: SLBuilderPage,
    },
  ],
};

export default slBuilderRoute;
